/* eslint-disable */

/** unique or primary key constraints on table "argo.location_attribute" */
export enum ArgoLocationAttributeConstraint {
  /** unique or primary key constraint on columns "context_id", "attribute_id", "location_id" */
  LocationAttributeLocationIdAttributeIdKey = 'location_attribute_location_id_attribute_id_key',
  /** unique or primary key constraint on columns "location_attribute_id" */
  LocationAttributePkey = 'location_attribute_pkey'
}

/** select columns of table "argo.location_attribute" */
export enum ArgoLocationAttributeSelectColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "argo.location_attribute" */
export enum ArgoLocationAttributeUpdateColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

